











































import { MissingInformationHandler } from "@/lib/notification/MissingUserInformationHandler";
import { INotification } from "@/store/interface/notification.interface";
import { NotificationModule } from "@/store/modules/notification.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Notifications extends Vue {
  informationsChecked = false;
  isLoading = false;

  get isSmallDisplay(): string {
    if (this.smallDisplay) {
      return "12";
    } else {
      return "auto";
    }
  }

  get smallDisplay(): boolean {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return true;
      case "sm":
        return true;
      case "md":
        return false;
      case "lg":
        return false;
      case "xl":
        return false;
    }
    return false;
  }

  async mounted() {
    if (!NotificationModule.isNotificationsLoaded) {
      try {
        NotificationModule.setIsNotificationsLoaded(true);
        await MissingInformationHandler.check();
      } catch (error) {
        this.$log.error(error);
      }
    }
  }

  get isNotification() {
    return NotificationModule.isNotification;
  }

  get notifications() {
    return NotificationModule.notifications;
  }

  popNotification(index: number) {
    NotificationModule.popNotification(index);
  }

  async processNotification(notification: INotification, index: number) {
    if (notification.action) {
      try {
        this.isLoading = true;
        await notification.action();
      } catch (error) {
        this.$log.error(error);
      } finally {
        this.isLoading = false;
      }
    }
    if (notification.location) {
      this.$router.push(notification.location);
      this.popNotification(index);
    }
  }
}
